const clientSettings = {
  fwwf: {
    authRequired: true,
    appName: "FWWF & Living Labs Project",
    subAppName: null,
    appColor: "#f6f4f1",
    alert: null,
    alertStatus: null,
    client: "fwwf",
    acceptedRoutes: [
      "My Ranches",
      "Season Manager",
      "Ranch Table Manager",
      "Data Viewer",
      "User Guide",
    ],

    mapSettings: {
      center: [-105.87, 56.03],
      zoom: 3,
      maxMapBounds: { sw: [-142.9, 32.52], ne: [-51.15, 84.29] },
      initialBasemap: {
        title: "Satellite Streets",
        url: "mapbox://styles/mapbox/satellite-streets-v11",
      },
      outlineAllPolygons: true,
    },

    appData: [{ path: "appData/refreshAppData", value: "FWWF_DATA_SELECTION" }],
    accountData: [{ path: "accountData/refreshDatasetList" }],

    dataViewerSettings: {
      layerControlsTimestep: false,
      allowPublicAccess: false,
      layout: {
        layerPanel: { include: true, open: true },
        dataPanel: { include: true, open: true },
        tablePanel: { include: false, open: false },
      },
      chartSettings: {
        chartTypes: ["bar"],
      },
    },

    // default selector for fwwf
    dataSelectionType: {
      type: "LayerLoader",
      selectionTitle: "Ranch",
      tagFilter: "Paddock Boundaries",
      allowCreateNewDataset: false,
      allowFeatureSelection: { allow: true, api: "some value" },
    },
  },
};

export default clientSettings;
